import {httpService} from "@/modules/common/services";

const VERTICALS = ["healthcare"] // Currently hard coded - with future option of getting from DB (core)

const getAccount = (params) => {
  return httpService.get("profile", params)
};

const getBusiness = () => {
  return httpService.get("profile/business")
};

const getSettings = () => {
  return httpService.get("profile/settings")
};

const getStaff = () => {
  return httpService.get("profile/staff")
};

const getGeoDataByIP = () => {
  return httpService.get("profile/geo_data_by_ip")
};

const checkVerticalExistance = (businessVertical) =>{
  return VERTICALS.includes(businessVertical)
}
const getChannels = async (client_uid) => {
  return httpService.get(`/business/messaging/v1/channels/contacts/${client_uid}`, {new_api: true})
}


export default {
  getAccount,
  getBusiness,
  getStaff,
  getSettings,
  getGeoDataByIP,
  checkVerticalExistance,
  getChannels
}

